var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 15.0857V16.0057C25.9988 18.1621 25.3005 20.2604 24.0093 21.9875C22.7182 23.7147 20.9033 24.9782 18.8354 25.5896C16.7674 26.201 14.5573 26.1276 12.5345 25.3803C10.5117 24.633 8.78465 23.2518 7.61096 21.4428C6.43727 19.6338 5.87979 17.4938 6.02168 15.342C6.16356 13.1903 6.99721 11.1421 8.39828 9.5028C9.79935 7.86354 11.6928 6.72111 13.7962 6.24587C15.8996 5.77063 18.1003 5.98806 20.07 6.86572M26 8L16 18.01L13 15.01",
    stroke: "#10BADF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletSecond);
export default __webpack_public_path__ + "static/media/bullet-second.4de448c897bf5e38d325b51191ad67a1.svg";
export { ForwardRef as ReactComponent };